var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusWhiteButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M18 11.719v.562c0 .31-.253.563-.563.563h-4.593v4.594a.564.564 0 0 1-.563.562h-.562a.564.564 0 0 1-.563-.563v-4.593H6.562A.564.564 0 0 1 6 12.28v-.562c0-.31.253-.563.563-.563h4.593V6.562c0-.309.253-.562.563-.562h.562c.31 0 .563.253.563.563v4.593h4.594c.309 0 .562.253.562.563Zm5.625.281c0 6.422-5.203 11.625-11.625 11.625S.375 18.422.375 12 5.578.375 12 .375 23.625 5.578 23.625 12Zm-1.5 0c0-5.62-4.56-10.125-10.125-10.125C6.38 1.875 1.875 6.435 1.875 12c0 5.62 4.56 10.125 10.125 10.125 5.62 0 10.125-4.56 10.125-10.125Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusWhiteButton);
export default __webpack_public_path__ + "static/media/plus-white_button.1299a4a04cfcd935243fbe4be853b64a.svg";
export { ForwardRef as ReactComponent };